export function gettext(message) {
    return window.gettext(message);
}

export function ngettext(message, messagePlural, count) {
    return window.ngettext(message, messagePlural, count);
}

export function pgettext(context, message) {
    return window.pgettext(context, message);
}

export function npgettext(context, message, messagePlural, count) {
    return window.npgettext(context, message, messagePlural, count);
}

export function interpolate(format, params) {
    const named = !(params instanceof Array);
    return window.interpolate(format, params, named);
}
